import { observer } from 'mobx-react-lite'
import { type BookkeepingCorrectCycleDialogViewModel } from './BookkeepingCorrectCycleDialogViewModel'
import { type CorrectWorkItemViewModel } from './CorrectWorkItemViewModel'
import { useActivation } from '@/hooks/view-model-hooks'
import {
  BookkeepingCorrectCycleDialog,
  BookkeepingCorrectCycleDialogWorkItemRow,
} from '@/features/jobs/details/components/BookkeepingCorrectCycleDialog'

export interface BookkeepingCorrectCycleDialogContainerProps {
  vm: BookkeepingCorrectCycleDialogViewModel
}

export const BookkeepingCorrectCycleDialogContainer = observer(
  function BookkeepingCorrectCycleDialogContainer({
    vm,
  }: BookkeepingCorrectCycleDialogContainerProps) {
    useActivation(vm)

    return (
      <BookkeepingCorrectCycleDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
        cycleNumber={vm.selectedCycle.number}
        itemCount={vm.correctedItems.length}
      >
        {vm.correctedItems.map((ci) => (
          <WorkItemRowContainer key={ci.workItemId} vm={ci} />
        ))}
      </BookkeepingCorrectCycleDialog>
    )
  },
)

interface WorkItemRowContainerProps {
  vm: CorrectWorkItemViewModel
}

const WorkItemRowContainer = observer(function WorkItemRowContainer({
  vm,
}: WorkItemRowContainerProps) {
  return (
    <BookkeepingCorrectCycleDialogWorkItemRow
      name={vm.name}
      description={vm.description}
      completedCount={vm.completedCount}
      min={vm.fieldLengths.correctAmount.min}
      max={vm.maxCorrectAmount}
      correctAmount={vm.correctAmount}
      isInvalid={Boolean(vm.validation.getError('correctAmount'))}
      onCorrectAmountChange={vm.setCorrectedItems}
    />
  )
})
